var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMorePolicy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.36 12.4C19.08 12.24 18.79 12.11 18.5 12C18.79 11.89 19.08 11.76 19.36 11.6C21.28 10.49 22.35 8.48 22.36 6.41C20.57 5.38 18.29 5.3 16.36 6.41C16.08 6.57 15.82 6.76 15.58 6.95C15.63 6.64 15.66 6.32 15.66 6C15.66 3.78 14.45 1.85 12.66 0.809998C10.87 1.85 9.65996 3.78 9.65996 6C9.65996 6.32 9.68996 6.64 9.73996 6.95C9.49996 6.75 9.23996 6.56 8.95996 6.4C7.03996 5.29 4.75996 5.37 2.95996 6.4C2.95996 8.47 4.02996 10.48 5.95996 11.59C6.23996 11.75 6.52996 11.88 6.81996 11.99C6.52996 12.1 6.23996 12.23 5.95996 12.39C4.03996 13.5 2.96996 15.51 2.95996 17.58C4.74996 18.61 7.02996 18.69 8.95996 17.58C9.23996 17.42 9.49996 17.23 9.73996 17.04C9.68996 17.36 9.65996 17.68 9.65996 18C9.65996 20.22 10.87 22.15 12.66 23.19C14.45 22.15 15.66 20.22 15.66 18C15.66 17.68 15.63 17.36 15.58 17.05C15.82 17.25 16.08 17.43 16.36 17.59C18.28 18.7 20.56 18.62 22.36 17.59C22.35 15.52 21.28 13.51 19.36 12.4ZM12.66 16C10.45 16 8.65996 14.21 8.65996 12C8.65996 9.79 10.45 8 12.66 8C14.87 8 16.66 9.79 16.66 12C16.66 14.21 14.87 16 12.66 16Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMorePolicy);
export default __webpack_public_path__ + "static/media/icon-more-Policy.feac984c5f3cca0914f1b36686e48b03.svg";
export { ForwardRef as ReactComponent };